import axiosInstance from "../helpers/axiosInstance";

export const fetchInventoryHistory = async (params = {}) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/inventory_history/index`, { params })
    return res.data
}